var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageDucGallery = function SvgImageDucGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.642 4.311H1.908c-.632 0-1.145.513-1.145 1.145v9.54c0 .633.513 1.145 1.145 1.145h12.734c.633 0 1.145-.512 1.145-1.144v-9.54c0-.633-.512-1.146-1.145-1.146ZM1.908 3.548A1.908 1.908 0 0 0 0 5.456v9.54c0 1.054.854 1.909 1.908 1.909h12.734a1.908 1.908 0 0 0 1.908-1.909v-9.54a1.908 1.908 0 0 0-1.908-1.908H1.908Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.844 11.909a1.526 1.526 0 0 0-2.04.136L.847 16.12a.382.382 0 1 1-.548-.532l3.958-4.076a2.29 2.29 0 0 1 3.06-.204l2.116 1.668 2.8-.98a2.29 2.29 0 0 1 1.524.003l2.59.92a.382.382 0 0 1-.256.719l-2.59-.92a1.527 1.527 0 0 0-1.015-.002l-2.35.822 3.46 2.782a.381.381 0 1 1-.478.595l-3.992-3.21-2.282-1.797ZM12.829 7.087a1.05 1.05 0 0 0-1.453-.35c-.501.31-.649.973-.325 1.461.29.439.87.592 1.344.355.544-.273.743-.949.434-1.466Zm-1.856-.999c.86-.53 1.995-.26 2.514.609a1.806 1.806 0 0 1-.748 2.538c-.818.41-1.821.148-2.327-.617a1.805 1.805 0 0 1 .561-2.53Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.718.766a.19.19 0 0 0-.216.147l-.646 2.909a.382.382 0 0 1-.745-.166L4.757.747A.954.954 0 0 1 5.838.012l13.299 2.114a.954.954 0 0 1 .79 1.109l-2.133 11.99a.763.763 0 0 1-.751.63h-.634a.382.382 0 1 1 0-.763h.634l2.132-11.99a.19.19 0 0 0-.158-.223L5.718.766Z",
    fill: "#000"
  })));
};
export default SvgImageDucGallery;